<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre1" id="pgepubid00000">LOURDES</h1>
<h2 class="sigilnotintoc sigil_not_in_toc" id="pgepubid00001">Of the Three Cities</h2>
<h2 class="sigilnotintoc sigil_not_in_toc" id="calibre_pb_1">By Emile Zola</h2>
<h3 class="sigilnotintoc1 sigil_not_in_toc" id="pgepubid00002">Translated By Ernest A. Vizetelly</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001_split_000.vue?9f99f952